import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

export const StyledIcon = styled(Icon)`
  height: ${rem('14px')};
  margin-right: ${rem('7px')};
  width: ${rem('7px')};
  display: none;
  transform: rotate(180deg);
  ${mediaqueries.greaterThan('mobile')`
    height: ${rem('18px')};
    left: 0;
    position: absolute;
    width: ${rem('9px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('12px')};
    margin: 0 ${rem('7px')};
    position: relative;
    display: block;  
    width: ${rem('6px')};
  `};
`;

export const StyledButtonLeft = styled.button`
  display: none;
  background: none;
  border: none;
  position: absolute;
  top: ${rem('5px')};
  &:last-of-type {
    display: block;
  }
  ${StyledIcon} {
    display: block;
    position: static;
    transform: rotate(0);
  }
  ${mediaqueries.greaterThan('desktop')`
    display: none;    
    ${StyledIcon} {
      display: none;
    }
  `};
`;

export const StyledList = styled.ol`
  display: flex;
  list-style: none;
  padding-left: 0;
`;

export const StyledElement = styled.li`
  align-items: center;
  cursor: pointer;
  display: none;
  font-size: ${props => props.theme.fontSize.small};
  justify-content: center;
  padding-left: 0;
  position: relative;
  transition: 0.3s;
  :hover {
    color: ${props => props.theme.colors.primary};
  }
  :before {
    content: none;
  }
  :last-child {
    pointer-events: none;
    display: flex;
    font-family: ${props => props.theme.fonts.medium};
    padding-left: ${rem('16px')};
    &:first-child {
      padding-left: 0;
    }
  }
  ${mediaqueries.greaterThan('mobile')`
    width: 100%;
  `};
  ${mediaqueries.greaterThan('tablet')`
    justify-content: flex-start;
  `};
  ${mediaqueries.greaterThan('desktop')`
    display: flex;
    font-size: ${rem('16px')};
    text-transform: initial;
    width: auto;
    :last-child {    
      padding-left: 0;
    }
  `};
`;
